"use strict";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var twoProduct = require("two-product");

var robustSum = require("robust-sum");

var robustScale = require("robust-scale");

var robustSubtract = require("robust-subtract");

var NUM_EXPAND = 5;
var EPSILON = 1.1102230246251565e-16;
var ERRBOUND3 = (3.0 + 16.0 * EPSILON) * EPSILON;
var ERRBOUND4 = (7.0 + 56.0 * EPSILON) * EPSILON;

function orientation_3(sum, prod, scale, sub) {
  return function orientation3Exact(m0, m1, m2) {
    var p = sum(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])));
    var n = sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0]));
    var d = sub(p, n);
    return d[d.length - 1];
  };
}

function orientation_4(sum, prod, scale, sub) {
  return function orientation4Exact(m0, m1, m2, m3) {
    var p = sum(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))));
    var n = sum(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))));
    var d = sub(p, n);
    return d[d.length - 1];
  };
}

function orientation_5(sum, prod, scale, sub) {
  return function orientation5Exact(m0, m1, m2, m3, m4) {
    var p = sum(sum(sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m1[3]), sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), -m2[3]), scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m3[3]))), sum(scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), -m4[3]), sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m1[3])))), sum(sum(scale(sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m3[3]), sum(scale(sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), -m4[3]), scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), m0[3]))), sum(scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m1[3]), sum(scale(sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), m2[3]), scale(sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m3[3])))));
    var n = sum(sum(sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m2[3])), sum(scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), m3[3]), scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m4[3]))), sum(sum(scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), -m1[3])), sum(scale(sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m2[3]), scale(sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m4[3]))));
    var d = sub(p, n);
    return d[d.length - 1];
  };
}

function orientation(n) {
  var fn = n === 3 ? orientation_3 : n === 4 ? orientation_4 : orientation_5;
  return fn(robustSum, twoProduct, robustScale, robustSubtract);
}

var orientation3Exact = orientation(3);
var orientation4Exact = orientation(4);
var CACHED = [function orientation0() {
  return 0;
}, function orientation1() {
  return 0;
}, function orientation2(a, b) {
  return b[0] - a[0];
}, function orientation3(a, b, c) {
  var l = (a[1] - c[1]) * (b[0] - c[0]);
  var r = (a[0] - c[0]) * (b[1] - c[1]);
  var det = l - r;
  var s;

  if (l > 0) {
    if (r <= 0) {
      return det;
    } else {
      s = l + r;
    }
  } else if (l < 0) {
    if (r >= 0) {
      return det;
    } else {
      s = -(l + r);
    }
  } else {
    return det;
  }

  var tol = ERRBOUND3 * s;

  if (det >= tol || det <= -tol) {
    return det;
  }

  return orientation3Exact(a, b, c);
}, function orientation4(a, b, c, d) {
  var adx = a[0] - d[0];
  var bdx = b[0] - d[0];
  var cdx = c[0] - d[0];
  var ady = a[1] - d[1];
  var bdy = b[1] - d[1];
  var cdy = c[1] - d[1];
  var adz = a[2] - d[2];
  var bdz = b[2] - d[2];
  var cdz = c[2] - d[2];
  var bdxcdy = bdx * cdy;
  var cdxbdy = cdx * bdy;
  var cdxady = cdx * ady;
  var adxcdy = adx * cdy;
  var adxbdy = adx * bdy;
  var bdxady = bdx * ady;
  var det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
  var permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
  var tol = ERRBOUND4 * permanent;

  if (det > tol || -det > tol) {
    return det;
  }

  return orientation4Exact(a, b, c, d);
}];

function slowOrient(args) {
  var proc = CACHED[args.length];

  if (!proc) {
    proc = CACHED[args.length] = orientation(args.length);
  }

  return proc.apply(undefined, args);
}

function proc(slow, o0, o1, o2, o3, o4, o5) {
  return function getOrientation(a0, a1, a2, a3, a4) {
    switch (arguments.length) {
      case 0:
      case 1:
        return 0;

      case 2:
        return o2(a0, a1);

      case 3:
        return o3(a0, a1, a2);

      case 4:
        return o4(a0, a1, a2, a3);

      case 5:
        return o5(a0, a1, a2, a3, a4);
    }

    var s = new Array(arguments.length);

    for (var i = 0; i < arguments.length; ++i) {
      s[i] = arguments[i];
    }

    return slow(s);
  };
}

function generateOrientationProc() {
  while (CACHED.length <= NUM_EXPAND) {
    CACHED.push(orientation(CACHED.length));
  }

  module.exports = proc.apply(undefined, [slowOrient].concat(CACHED));

  for (var i = 0; i <= NUM_EXPAND; ++i) {
    module.exports[i] = CACHED[i];
  }
}

generateOrientationProc();
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(NUM_EXPAND, "NUM_EXPAND", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(EPSILON, "EPSILON", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(ERRBOUND3, "ERRBOUND3", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(ERRBOUND4, "ERRBOUND4", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(orientation_3, "orientation_3", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(orientation_4, "orientation_4", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(orientation_5, "orientation_5", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(orientation, "orientation", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(orientation3Exact, "orientation3Exact", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(orientation4Exact, "orientation4Exact", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(CACHED, "CACHED", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(slowOrient, "slowOrient", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(proc, "proc", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
  reactHotLoader.register(generateOrientationProc, "generateOrientationProc", "/home/yatham/Dev_BHS_Portal/node_modules/robust-orientation/orientation.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();